import { BenchLogoSmall } from "./bench-logo-small";

export default function BenchHero({ showBenchLogo }: { showBenchLogo?: true }) {
  return (
    <div className="flex self-stretch flex-col items-center mb-4">
      <div className="flex items-center justify-center text-8xl lg:text-9xl">
        <span className="absolute mx-auto flex border w-fit bg-gradient-to-r blur-xl from-primary to-teal-500 bg-clip-text box-content text-transparent text-center select-none font-thin">
          Bench
        </span>
        <div className="relative top-0 w-fit h-auto justify-center flex bg-gradient-to-r items-center from-primary to-teal-500 bg-clip-text text-transparent text-center select-auto font-thin">
          Bench
        </div>
      </div>
      <div className="flex items-center justify-center text-2xl lg:text-3xl flex-wrap">
        { showBenchLogo ? <BenchLogoSmall className="mr-3 w-9 h-9 -mb-1" /> : null }
        <span className="text-transparent bg-clip-text bg-gradient-to-r items-center from-primary to-teal-500 ">
          constant price markets
        </span>
      </div>
    </div>
  );
}
